module.exports = __webpack_public_path__ + "static/media/calendar.1b69c8da.svg";